import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { WorkOrderState } from "../../models";
import { remove } from "../../api/generic-api";
import { RQ } from "../../globals/enums";
import { deleteEntity } from "../../utils";

export const useDeleteWorkOrderState = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation((id: string) => remove("work-order-states", id), {
    onSuccess: (_, id) => {
      enqueueSnackbar("Work Order State Deleted", { variant: "success" });
      queryClient.setQueryData(
        RQ.WORK_ORDER_STATES,
        (workOrderStates: WorkOrderState[] | undefined) => {
          return !workOrderStates
            ? []
            : deleteEntity<WorkOrderState>(workOrderStates, "id", id);
        }
      );
    },
    onError: () => {
      enqueueSnackbar("Work Order State Deleting Error", { variant: "error" });
    },
  });
};
